export default __webpack_public_path__ + "static/media/megamog-bg.00e9a2ad.jpg";